/**
 * The reason a verification is in its status, as display text. The backend
 * renders each status_detail entry's message, so the text matches the old
 * plain-text reason.
 */
export function formatStatusDetail(
  statusDetail: StatusDetailEntryMessage[] | null | undefined,
): string | null {
  if (!statusDetail?.length) return null;
  return statusDetail.map((entry) => entry.message).join(" | ");
}

/**
 * statusDetail first; the legacy reason text only for rows not yet backfilled
 * (WL-4746). The backend sends verificationStatusReason only when statusDetail is
 * empty.
 */
export function verificationReason(
  verification: Pick<
    InsuranceVerificationMessage,
    "statusDetail" | "verificationStatusReason"
  >,
): string | null {
  return (
    formatStatusDetail(verification.statusDetail) ??
    verification.verificationStatusReason ??
    null
  );
}
